'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Clone = exports.macro = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var macro = exports.macro = function macro() {
  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (template) {
    var componentKeys = Object.keys(components);

    var MacroComponent = function (_React$Component) {
      _inherits(MacroComponent, _React$Component);

      function MacroComponent(props) {
        _classCallCheck(this, MacroComponent);

        var _this = _possibleConstructorReturn(this, (MacroComponent.__proto__ || Object.getPrototypeOf(MacroComponent)).call(this));

        _this.parseChildren = function (children) {
          return _react2.default.Children.toArray(children).reduce(function (a, child) {
            a[child.type.macroName] = child;
            return a;
          }, {});
        };

        _this.getElements = function (anyChildren) {
          var children = _this.parseChildren(anyChildren);

          return componentKeys.reduce(function (a, key) {
            a[key] = children[key];
            return a;
          }, {});
        };

        _this.state = {
          elements: _this.getElements(props.children)
        };
        return _this;
      }

      _createClass(MacroComponent, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(next) {
          if (next.children === this.props.children) return;
          var elements = this.getElements(next.children);
          this.setState({
            elements: elements
          });
        }
      }, {
        key: 'render',
        value: function render() {
          var elements = this.state.elements;
          return template(elements, this.props);
        }
      }]);

      return MacroComponent;
    }(_react2.default.Component);

    MacroComponent.propTypes = {
      children: function children(props, name) {
        var children = _react2.default.Children.toArray(props.children);

        for (var i = 0; i < children.length; i++) {
          var child = children[i];
          if (components.hasOwnProperty(child.type.macroName)) continue;
          return new Error(['Invalid child component `', child.type, '`. ', 'Must be one of: ', componentKeys.join(', ')].join(''));
        }
      }
    };

    var _loop = function _loop(key) {
      // cloned to keep multiple components mapped properly
      MacroComponent[key] = function (props) {
        return _react2.default.createElement(components[key], props);
      };

      MacroComponent[key].macroName = key;
    };

    for (var key in components) {
      _loop(key);
    }

    MacroComponent.isMacroComponent = true;
    return MacroComponent;
  };
};

var Clone = function Clone(_ref) {
  var element = _ref.element,
      props = _objectWithoutProperties(_ref, ['element']);

  return element ? _react2.default.cloneElement(element, _extends({}, props, element.props)) : false;
};

exports.Clone = Clone;
exports.default = macro;